import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { editContent } from "../../modules/editor";

import { getDonusUrl, getDonusProducts } from '../../modules/editor/service';

import FieldSection from './FieldSection';
import SelectedContentDonationProduct from './SelectedContentDonationProduct';

import backButton from '../../assets/images/icon/btn-back.png';

const donationTypeSet: any = {
	donationA: [['cta']],
	donationB: [['cta'], ['cta']]
}

type Props = {
	selectedContentId: number;
	currentContent: any;
}

function SelectedContentDonation({ selectedContentId, currentContent }: Props) {
	const [donationType, setDonationType] = useState('donationA');
	const [donusUrl, setDonusUrl] = useState('');
	const [products, setProducts] = useState([] as any);
	const [showDetailSetting, setShowDetailSetting] = useState(false);

	const dispatch = useDispatch();

	useEffect(() => {
		setDonationType(currentContent?.content?.type);
	}, [currentContent]);

	useEffect(() => {
		getDonusInfo();
	}, []);

	const getDonusInfo = async()  =>{
		const url = await getDonusUrl();
		setDonusUrl(url);
		try {
			const { productList } = await getDonusProducts();		
			setProducts(productList);
		} catch (error) {
			console.error(error);
		}
	}

	const onChangeLayout = (value: string) => {
		dispatch(editContent({ target: `${selectedContentId}/column`, data: donationTypeSet[value] }));
		dispatch(editContent({ target: `${selectedContentId}/type`, data: value }));
	}	

	return (
		<div className="editor-sidebar-selected-content-setting">			
			<FieldSection
				labelName=""
				label={false}
				fullWidth={true}
			>
				<div style={{paddingTop:'15px'}}>
					<button className="btn medium" onClick={() => {setShowDetailSetting(true)}}>모금 상품 설정하기</button>
				</div>
			</FieldSection>

			<h3 className="field-section-title">버튼 수</h3>
			<FieldSection
				labelName=""
				label={false}
				fullWidth={true}
			>
				<div className="layout-field">
					<button className={currentContent?.content?.column?.length === 1 ? 'btn medium primary-black' : 'btn medium line tertiary'} onClick={() => {onChangeLayout('donationA')}}>1단</button>
					<button className={currentContent?.content?.column?.length === 2 ? 'btn medium primary-black' : 'btn medium line tertiary'} onClick={() => {onChangeLayout('donationB')}}>2단</button>
				</div>
			</FieldSection>

			<div className={showDetailSetting ? 'editor-sidebar-selected-content active' : 'editor-sidebar-selected-content'}>
				<header className="selected-content-header">
					<h2>
						<button onClick={() => {setShowDetailSetting(false)}}>
							<img src={backButton} alt="back" width="42"/>
						</button>
						모금 상품 설정하기
					</h2>
				</header>
				<h3 className="field-section-title">왼쪽 버튼</h3>
				<SelectedContentDonationProduct 
					target={`${selectedContentId}/content/0`}
					value={currentContent?.content?.content[0].buttonLink}
					domain={donusUrl}
					products={products}
				/>
				{
					currentContent?.content.column.length === 2 && (
						<>
							<h3 className="field-section-title">오른쪽 버튼</h3>
							<SelectedContentDonationProduct 
								target={`${selectedContentId}/content/1`}
								value={currentContent?.content?.content[1].buttonLink}
								domain={donusUrl}
								products={products}
							/>
						</>
					)
				}
			</div>

			
		</div>
	);
}

export default SelectedContentDonation;